import { FunctionComponent, useEffect, useRef } from 'react';
import { Box, Modal, withStyles, CircleButton } from 'vopay';
import ElinxForm from '@/components/Settings/ELinx/ElinxSettingsForm';
import { Title } from 'UI';
import styles from './ElinxSettingsDialogue.module.scss';
import { useTranslation } from 'react-i18next';

export interface ElinxSettingsDialogueProps {
  isVisible: boolean;
  onCloseModal: () => void;
  onFetchElinxSettings: () => Promise<void>;
}

const classes = withStyles(styles);

const ElinxSettingsDialogue: FunctionComponent<ElinxSettingsDialogueProps> = ({
  isVisible,
  onCloseModal,
  onFetchElinxSettings,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('translations', { keyPrefix: 'Elinx.SettingsDialogue' });

  useEffect(() => {
    if (isVisible && containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const controller = new AbortController();
    const { signal } = controller;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        onCloseModal();
        controller.abort();
      }
    };
    window.addEventListener('keydown', handleKeyDown, { signal });
    return () => {
      controller.abort();
    };
  }, [isVisible, onCloseModal]);

  return (
    <Modal isVisible={isVisible} enableBgClick={false}>
      <div ref={containerRef} className={classes('container', 'scrollbar')}>
        <Box flx="col" gap="sm" pb="xmd" height="auto">
          <Box jc="sb" ai="center">
            <Title level="2">{t('title')}</Title>
            <CircleButton icon="close" size="large" colorScheme="neutral" onClick={onCloseModal} />
          </Box>
          <p className={classes('description')}>{t('subTitle')}</p>
        </Box>
        <ElinxForm onClose={onCloseModal} onSubmit={onFetchElinxSettings} />
      </div>
    </Modal>
  );
};

export default ElinxSettingsDialogue;
